import React from "react";
import { createRoot } from "react-dom/client";
import TopicalMapGenerator from "../components/free-tools/TopicalMapGenerator";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("topical-map-generator-main");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <TopicalMapGenerator />
      </>
    );
  }
});
